import * as React from 'react';
import NotificationComponent from "../components/NotificationComponent/NotificationComponent";

import {connect} from "react-redux";

export interface INotificationProps {
    display: boolean,
    loading: boolean,
    loggedIn: boolean,
    text: string,
}

class NotificationContainer extends React.PureComponent<INotificationProps> {
    public render() {
        return (
            <NotificationComponent {...this.props}/>
        );
    }
}

const mapStateToProps = (store: any) => ({
    display: store.notification.display,
    loading: store.notification.loading,
    loggedIn: store.io.loggedIn,
    text: store.notification.text,
});

export default connect(mapStateToProps)(NotificationContainer);


// WEBPACK FOOTER //
// ./src/containers/NotificationContainer.tsx